import { api } from './api'
import { MusicalGenresDataProps } from '@/types/musicalGenresProps'
import {
  type PaginatedResponseProps,
  normalizePaginationMeta,
} from '@/types/paginationProps'

export async function fetchGenresOptions(): Promise<MusicalGenresDataProps[]> {
  const firstPageResponse = await api.get<
    PaginatedResponseProps<MusicalGenresDataProps>
  >('/genres', {
    params: {
      page: 1,
    },
  })

  const firstPageGenres = firstPageResponse.data.data
  const pagination = normalizePaginationMeta(
    firstPageResponse.data.meta,
    firstPageGenres.length,
  )

  if (pagination.lastPage <= 1) {
    return firstPageGenres
  }

  const nextPagesResponses = await Promise.all(
    Array.from({ length: pagination.lastPage - 1 }, (_, index) =>
      api.get<PaginatedResponseProps<MusicalGenresDataProps>>('/genres', {
        params: {
          page: index + 2,
        },
      }),
    ),
  )

  return firstPageGenres.concat(
    nextPagesResponses.flatMap((response) => response.data.data),
  )
}
